import Vue from "vue";
import App from "./App.vue";
import VueScrollTo from "vue-scrollto";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import AOS from "aos";
import "aos/dist/aos.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import store from "./store";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { languageHelper } from "@/helpers";
import fire from "@/config/fire";
import firebase from "firebase/app";
import "firebase/analytics";
library.add(faSpinner);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

Vue.use(BootstrapVue);

Vue.use(VueSweetalert2);

languageHelper.setI18nConfig();

firebase.initializeApp(fire);
firebase.analytics();


new Vue({
  store,
  created() {
    AOS.init();
  },
  render: (h) => h(App),
}).$mount("#app");
